<template>
    <div>
        <v-snackbar
            v-for="(item, i) in items"
            :key="item.uuid"
            :value="i === 0"
            :timeout="timeout"
            :color="item.color"
            :top="top"
            :right="right"
            :absolute="absolute"
            :auto-height="autoHeight"
            :bottom="bottom"
            :left="left"
            :multi-line="multiLine"
            :vertical="vertical"
        >
            <w-span span-class="subheading">
                {{ item.message }}
            </w-span>
            <w-btn
                v-if="items.length > 1"
                color="white"
                flat
                @click="removeItem(item.uuid)"
            >
                Next ({{items.length - 1}} more)
            </w-btn>
            <w-btn
                v-else
                color="white"
                icon-name="close"
                flat
                @click="removeItem(item.uuid)"
            ></w-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import {findIndex, first, isEmpty} from 'underscore'

    import WBtn from '../WBtn'
    import WSpan from '../WSpan'

    /**
     * Displays a snackbar. Supports queues and can be configured to be displayed in the required location on the screen.
     */
    export default {
        name: 'WSnackbarQueue',
        components: {
            WBtn,
            WSpan
        },
        data: () => ({
            timeouts: []
        }),
        props: {
            /**
             * Array for items to display [{id: '', color: '', message: ''}].
             */
            items: {
                type: Array,
                required: true
            },
            /**
             * Timeout before snackbar items disappear from the screen.
             */
            timeout: {
                type: Number,
                default: 7000
            },
            /**
             * Display the snackbar at the top of the screen.
             */
            top: {
                type: Boolean,
                default: true
            },
            /**
             * Display the snackbar at the right of the screen.
             */
            right: {
                type: Boolean,
                default: false
            },
            /**
             * Display the snackbar absolutely.
             */
            absolute: {
                type: Boolean,
                default: false
            },
            /**
             * Make the snackbar height dynamic.
             */
            autoHeight: {
                type: Boolean,
                default: false
            },
            /**
             * Display the snackbar at the bottom of the screen.
             */
            bottom: {
                type: Boolean,
                default: false
            },
            /**
             * Display the snackbar at the left of the screen.
             */
            left: {
                type: Boolean,
                default: false
            },
            /**
             * Makes the snackbar higher (for mobile).
             */
            multiLine: {
                type: Boolean,
                default: false
            },
            /**
             * Stacks snackbar content vertically (for mobile).
             */
            vertical: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            processItems () {
                const vm = this
                if (!isEmpty(vm.items)) {
                    const item = first(vm.items)
                    if (item && findIndex(vm.timeouts, {uuid: item.uuid}) === -1) {
                        vm.timeouts.push({
                            uuid: item.uuid,
                            id: setTimeout(() => vm.removeItem(item.uuid), vm.timeout)
                        })
                    }
                }
            },
            removeItem (uuid) {
                const index = findIndex(this.timeouts, {uuid})

                if (index !== -1) {
                    clearTimeout(this.timeouts[index].id)
                    this.timeouts.splice(index, 1)
                }

                /**
                 * Remove event.
                 * @type {string}
                 */
                this.$emit('remove', uuid)
                this.processItems()
            }
        },
        watch: {
            items () {
                this.processItems()
            }
        }
    }
</script>
